<template>
    <div class="container">
        <div class="title">
            <div class="row">
                <div class="d-flex align-items-center ms-4 mt-4">
                    <h2 class="flex-shrink-0">{{ this.$helper.formatDate(summary.created_at, true) }}</h2>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-xl-8">
                <div class="summary-box">
                    <ul class="list-group stock-view-summary">
                        <li class="list-group-item bg-transparent flex-space-between">
                            <span class="name">Last Update</span><span class="value">{{ this.$helper.formatDate(summary.updated_at, true) }}</span>
                        </li>
                        <li class="list-group-item bg-transparent flex-space-between">
                            <span class="name">For Investment:</span><span class="value">{{ this.$helper.formatPrice(summary.for_investment) }}</span>
                        </li>
                        <li class="list-group-item bg-transparent flex-space-between">
                            <span class="name">Invest</span><span class="value">{{ this.$helper.formatPrice(summary.invest) }}</span>
                        </li>
                        <li class="list-group-item bg-transparent flex-space-between">
                            <span class="name">Available</span><span class="value">{{ this.$helper.formatPrice(summary.available) }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="this.summaryInvestmentRows">
            <div class="row">
              <div class="col-8">
                <div class="container-fluid pt-4 px-4">
                    <div class="panel-card text-left p-4">
                        <Investment :row ='this.summaryInvestmentRows'></Investment>
                    </div>
                </div>
              </div>
              <div class="col-4">
                <InvestmentChart :row='this.summaryInvestmentRows'></InvestmentChart>
              </div>
            </div>
        </div>
        <div v-if="this.typeWiseTotalInvestment">
            <div class="row g-4">
                <div class="col-sm-12 col-xl-6" v-for="(_type, index) in this.typeWiseTotalInvestment" :key="index">
                    <div class="container-fluid pt-4 px-4">
                        <div class="panel-card text-left p-4">
                            <InvestmentType :row ='_type' :title='index'></InvestmentType>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>

import Investment from '@/views/investment_plan/summary/Investment.vue';
import InvestmentChart from '@/views/investment_plan/summary/Investment_chart.vue';
import InvestmentType from '@/views/investment_plan/summary/Investment_type.vue';

import gql from 'graphql-tag'

const SUMMARY_QUERY = gql`
query Summary($investmentSummaryId: ID!) {
  summary(investment_summary_id: $investmentSummaryId) {
    investment_summary_id
    for_investment
    invest
    available
    created_at
    updated_at
  }
}`;

const SUMMARY_INVESTMENT_ROWS_QUERY = gql`
query SummaryInvestmentRows($investmentSummaryId: ID!) {
  summaryInvestmentRows(investment_summary_id: $investmentSummaryId) {
    investment_id
    investment_summary_id
    investment_type_id
    invest
    created_at
    investment_type {
      investment_type_id
      name
    }
  }
}
`;

const SUMMARY_WISE_INVESTMENT_QUERY = gql`
query SummaryWiseInvestment($investmentSummaryId: ID!) {
  summaryWiseInvestment(investment_summary_id: $investmentSummaryId) {
    investment_id
    investment_summary_id
    investment_type_id
    invest
    created_at
    investment_type {
      investment_type_id
      name
    }
  }
}`;

export default {
    name: 'investment-plan-details',
    components: {
        Investment,
        InvestmentChart,
        InvestmentType
    },
    data() {
        return {
            summary: [],
            summaryInvestmentRows: [],
            typeWiseTotalInvestment: [],
            summaryWiseInvestment: [],
        }
    },
    methods: {
        getSummaryWiseInvestment(){
            let typeWiseTotalInvestment = {};
            this.summaryWiseInvestment.forEach(element => {
                if(typeWiseTotalInvestment[element.investment_type.name] !== undefined){
                    typeWiseTotalInvestment[element.investment_type.name].push({'investment_type_id' : element.investment_type_id, 'type': element.investment_type.name, 'amount': element.invest, 'created_at': element.created_at});
                } else {
                    typeWiseTotalInvestment[element.investment_type.name] = [{'investment_type_id' : element.investment_type_id, 'type': element.investment_type.name, 'amount': element.invest, 'created_at': element.created_at}];
                }
            });
            return this.typeWiseTotalInvestment = typeWiseTotalInvestment;
        }
    },
    async mounted(){
      await this.$apollo.queries.summaryWiseInvestment.refetch();
      await this.getSummaryWiseInvestment();
    },
    apollo: {
      summary: {
        query: SUMMARY_QUERY,
        variables () {
          return {
            investmentSummaryId: this.$route.query.id
          }
        },
        error(error){
          this.alertStore$.error(JSON.stringify(error.message));
        }
      },
      summaryInvestmentRows:{
        query:SUMMARY_INVESTMENT_ROWS_QUERY,
        variables () {
          return {
            investmentSummaryId: this.$route.query.id
          }
        },
        error(error){
          this.alertStore$.error(JSON.stringify(error.message));
        }
      },
      summaryWiseInvestment:{
        query:SUMMARY_WISE_INVESTMENT_QUERY,
        variables () {
          return {
            investmentSummaryId: this.$route.query.id
          }
        },
        error(error){
          this.alertStore$.error(JSON.stringify(error.message));
        }
      }
    },
}
</script>

<style scoped>
.panel-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}
</style>